import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, IconButton, Modal } from "@mui/material";

import useMediaQuery from "../../customHooks/useMediaQuery";
import { SwipeableDrawer } from "../swipeable-drawer";
import Typography from "../Typography";
import * as styles from "./ModalOrDrawerContainerStyles";

interface ModalOrDrawerContainerProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  children: JSX.Element;
}

export const ModalOrDrawerContainer = ({
  open,
  title,
  handleClose,
  children,
}: ModalOrDrawerContainerProps) => {
  const isMdSize = useMediaQuery("(min-width:900px)");
  if (isMdSize) {
    return (
      <Modal
        onClose={handleClose}
        open={open}
        sx={{
          display: "grid",
          placeItems: "center",
        }}
      >
        <Box sx={styles.root}>
          <Box sx={styles.titleContainer}>
            <IconButton sx={styles.closeIcon} onClick={handleClose}>
              <CloseRoundedIcon />
            </IconButton>
            <Typography variant="btnMedium" sx={styles.title}>
              {title}
            </Typography>
          </Box>
          <Box sx={styles.childrenContainer}>{children}</Box>
        </Box>
      </Modal>
    );
  } else {
    return (
      <SwipeableDrawer open={open} onClose={handleClose} onOpen={() => {}}>
        <Box sx={{ p: 2 }}>{children}</Box>
      </SwipeableDrawer>
    );
  }
};
